import { render } from "./InfoText.vue?vue&type=template&id=2f3dfdf4&scoped=true"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"

import "./InfoText.vue?vue&type=style&index=0&id=2f3dfdf4&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3dfdf4"]])

export default __exports__